(function () {
  'use strict';
  function initialize(root) {
    var system = root.querySelector('.aorvo-pdp-decision-system');
    if (!system || system.dataset.aorvoV2Ready) return;
    var modules = Array.from(system.children).filter(function (node) { return node.matches('details.aorvo-pdp-decision-module'); });
    if (!modules.length) return;
    var model = root.aorvoPdpViewModel;
    var selectedRoom = model && model.attestationVerified && model.selectedRoomSlot && model.media.filter(function (item) { return item.role === 'ROOM_INSTALLED' && item.slot === model.selectedRoomSlot; });
    var primaryId = selectedRoom && selectedRoom.length === 1 ? selectedRoom[0].mediaGid.split('/').pop() : null;
    modules.filter(function (node) { return node.dataset.aorvoDecisionRole === 'Room / Installed'; }).forEach(function (node) {
      var media = node.querySelector('[data-aorvo-source-id]');
      if (primaryId && (!media || media.dataset.aorvoSourceId !== primaryId)) node.dataset.aorvoV2HistoricalScene = 'true';
    });
    system.dataset.aorvoV2Ready = 'true';
    var groups = [
      { key: 'space', roles: ['Room / Installed'] },
      { key: 'dimensions', roles: ['Dimension / Scale'] },
      { key: 'materials', roles: ['Detail / Craftsmanship', 'Alternate Structure View', 'Configuration Comparison', 'Configuration Comparison / Specification Overview'] },
      { key: 'specifications', roles: ['Installation / Function', 'Function / Fit / Clearance'] },
      { key: 'policies', roles: ['Purchase policies'] }
    ];
    var desktop = window.matchMedia('(min-width: 768px)');
    groups.forEach(function (group) {
      var children = modules.filter(function (node) { return group.roles.includes(node.dataset.aorvoDecisionRole) && !node.hasAttribute('data-aorvo-v2-historical-scene'); });
      if (!children.length) return;
      var wrapper = document.createElement('details');
      wrapper.className = 'aorvo-pdp-v2-group';
      wrapper.dataset.aorvoV2Group = group.key;
      wrapper.open = desktop.matches;
      var summary = document.createElement('summary');
      summary.textContent = root.getAttribute('data-aorvo-v2-' + group.key);
      var body = document.createElement('div');
      body.className = 'aorvo-pdp-v2-group__body';
      children.forEach(function (node) {
        node.dataset.aorvoV2Member = 'true';
        node.open = true;
        var heading = node.querySelector(':scope > summary');
        if (heading) heading.hidden = true;
        body.append(node);
      });
      wrapper.append(summary, body);
      system.append(wrapper);
      function refresh() { wrapper.hidden = !children.some(function (node) { return !node.hidden; }); }
      children.forEach(function (node) { new MutationObserver(refresh).observe(node, { attributes: true, attributeFilter: ['hidden'] }); });
      refresh();
    });
    modules.filter(function (node) { return !node.hasAttribute('data-aorvo-v2-member'); }).forEach(function (node) { system.append(node); });
    function layout() { system.querySelectorAll('.aorvo-pdp-v2-group').forEach(function (node) { node.open = desktop.matches; }); }
    desktop.addEventListener('change', layout);
  }
  function start() {
    document.querySelectorAll('[data-aorvo-pdp-v2]').forEach(function (root) {
      initialize(root);
      if (!root.aorvoV2Observer) {
        root.aorvoV2Observer = new MutationObserver(function () { initialize(root); });
        root.aorvoV2Observer.observe(root, { childList: true, subtree: true });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
